import React__default from 'react';
import { c as TouchLinkContent, C as ChildrenContainer, d as TouchLinkIcon } from './TouchLink.styles-DBynuPNk.js';
import { b as angleInlineEnd } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const TouchLinkBody = ({
  children
}) => /*#__PURE__*/React__default.createElement(TouchLinkContent, null, /*#__PURE__*/React__default.createElement(ChildrenContainer, null, children), /*#__PURE__*/React__default.createElement(TouchLinkIcon, {
  type: angleInlineEnd
}));

export { TouchLinkBody as T };
//# sourceMappingURL=TouchLinkBody-CqATf5Vk.js.map
